import React from "react";
import HOC from "../../components/HOC";
import PageTemplate from "../../components/common/particles.jsx/PageTemplate";
import BreadcrumbRetur from "../../components/screen/Retur/BreadcrumbRetur";
import { ThemeProvider } from "@mui/material";
import { theme } from "../../components/constants/muiTheme";
import ReturSellList from "../../components/screen/Retur/ReturSellList";

const ReturSellPage = () => {
  return (
    <div className="">
      <PageTemplate
        header="Retur Penjualan"
        mainComponent={
          <ThemeProvider theme={theme}>
            <ReturSellList />
          </ThemeProvider>
        }
        breadcrumb={<BreadcrumbRetur />}
        pageRole={47}
      />
    </div>
  );
};

export default HOC(ReturSellPage);
